export type RowLabelProps = {
  readonly className?: string
  readonly CustomComponent?: React.ReactNode
  readonly label?: React.ReactNode | string
  readonly path: string
  readonly rowNumber?: number
}
